import { Button, Grid, Stack, Typography } from '@mui/material'
import React, { useState } from 'react'
import NormalAbnormal from '../NormalAbnormal'
import AnDateTimePicker from '../../../../../components/DateTime/DateTimePicker'
import moment from 'moment'
import CustomSelect from '../CustomSelect'
import AssessmentText from '../AssessmentText'

const HeadInjury = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} lg={6}>
        <Typography variant="title2">Head Injury</Typography>
      </Grid>
      <Grid item xs={12} lg={6}>
        <AnDateTimePicker
          date={moduleValues.dateTime}
          fullWidth
          size="small"
          onChange={(newDate) =>
            setModuleValues((prev) => ({
              ...prev,
              dateTime: newDate,
            }))
          }
        />
      </Grid>
      <NormalAbnormal
        fieldName="Pupils"
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
      />
      <NormalAbnormal
        fieldName="Memory"
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
      />
      <NormalAbnormal
        fieldName="Vision"
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
      />
      <NormalAbnormal
        fieldName="Coordination"
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
      />
      <CustomSelect
        label="Blood / Fluid from nose or ear"
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        options={['Yes', 'No']}
      />
      <CustomSelect
        label="Was patient knocked out?"
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        options={['Yes', 'No', 'Unknown']}
      />
      <CustomSelect
        label="Battle's Sign"
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        options={['Yes', 'No']}
      />
      <CustomSelect
        label="Seizure since Injury"
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        options={['Yes', 'No', 'Unknown']}
      />
      <CustomSelect
        label="Amnesia before/after event"
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        options={['Yes', 'No']}
      />
      <CustomSelect
        label="Vomiting Since Injury"
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        options={['Yes', 'No']}
      />
      <CustomSelect
        label="Current Drug / Alcohol Intoxication"
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        options={['Yes', 'No', 'Unknown']}
      />
      <CustomSelect
        label="Current Anticoagulant Therapy"
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        options={['Yes', 'No', 'Unknown']}
      />
      <AssessmentText
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
      />
      <Grid item xs={12}>
        <Button
          variant="contained"
          fullWidth
          color="success"
          onClick={() => submitModule('Head Injury', moduleValues)}
        >
          Submit
        </Button>
      </Grid>
    </Grid>
  )
}

export default HeadInjury
